import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import StatusPill from "@/components/StatusPill";

export default function PilRow({ pil, index }) {
  const num = String(pil.seq ?? (index + 1)).padStart(2, "0");
  return (
    <Link
      to={`/pil/${pil.pil_code.toLowerCase()}`}
      data-testid={`pil-row-${pil.pil_code}`}
      className="group block border-b border-npst-line py-8 px-2 sm:px-4 hover:bg-npst-goldLight/50 transition-colors duration-200 rounded-lg"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-baseline">
        <div className="md:col-span-1 font-serif text-4xl md:text-5xl font-light text-npst-goldBorder group-hover:text-npst-gold transition-colors leading-none">
          {num}
        </div>
        <div className="md:col-span-8 space-y-3">
          <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-npst-ink leading-tight group-hover:text-npst-navy transition-colors">
            {pil.title}
          </h3>
          <div className="flex flex-wrap gap-x-6 gap-y-1.5 text-[11px] font-sans uppercase tracking-[0.12em] text-npst-muted">
            <span><span className="text-npst-gold font-semibold">Court · </span>{pil.court}</span>
            <span className="font-mono normal-case tracking-normal"><span className="text-npst-gold font-semibold uppercase tracking-[0.12em]">Case · </span>{pil.case_number}</span>
          </div>
          {pil.cause_of_action && (
            <p className="text-sm text-npst-inkSoft leading-relaxed max-w-2xl line-clamp-2">{pil.cause_of_action}</p>
          )}
        </div>
        <div className="md:col-span-3 flex md:flex-col md:items-end gap-3 justify-between">
          <StatusPill status={pil.status} />
          <span className="inline-flex items-center gap-1.5 text-xs font-sans font-semibold uppercase tracking-[0.15em] text-npst-navy group-hover:gap-2.5 transition-all">
            View Case <ArrowRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}
